<template>
  <div @load="loading">
  <div class="gameplay_title_container">
    <div class="gameplay_title">
      {{ getTranslations.home_game_memory_attention_rolling_list_question }}
    </div>
  </div>
  <div class="gameplay_game_box_list gameplay_tap_box att8">
      <div class="gameplay_btns_row first">
        <img src="" class="image_showcase">
        <!-- <img src="static/images/game_images/attention_08/2.png" class="knot_box rejected"> -->
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-nested-ternary: "off" */

import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';


export default {
  name: 'AttentionRollingList',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      data: 0,
      secondsElapsed: 0,
      symbolInRow: 0,
      gameInfo: null,
      imageMatrix: [],
    };
  },
  created() {
    console.log('in Game created hook');
    this.initGameData();
  },
  mounted() {
    document.querySelector('.image_showcase').src = this.gameInfo.attCards[0].card.url;
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        if (this.secondsElapsed === this.gameInfo.attCards.length) {
          clearInterval(this.timer);
          this.changeBrainiacMiniGameType('ATT_ROLLING_LIST_QUIZ');
        }
        if (this.secondsElapsed < this.gameInfo.attCards.length) {
          document.querySelector('.image_showcase').src = this.gameInfo.attCards[this.secondsElapsed].card.url;
        }
        this.secondsElapsed += 1;
      }, 10000 / this.gameInfo.attCards.length);
    });
    this.$nextTick(() => { this.loading(); });
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
  },
  methods: {
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
    },
    loading() {
      gameplayFooter();
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/attention/AttentionRollingList.vue